<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Guest Pass</h4>
    <button type="button" class="close" aria-label="Close"
            (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="numPasses">
        Number of Guest Passes to Add
      </label>
      <input type="number"
             class="form-control"
             id="numPasses"
             name="numPasses"
             min="1" max="10" step="1"
             [(ngModel)]="numPasses">
    </div>

    <div class="form-group">
      <label for="eligibility">Can Be Used By</label>
      <select class="custom-select"
              id="eligibility"
              name="eligibility"
              [(ngModel)]="eligibility">
        <option [ngValue]="GuestPassEligibility.allCustomers">All Customers</option>
        <option [ngValue]="GuestPassEligibility.lapsedCustomersOnly">Lapsed Customers Only</option>
        <option [ngValue]="GuestPassEligibility.newCustomersOnly">New Customers Only</option>
      </select>
      <small class="form-text text-muted" *ngIf="orgConfigService.getGuestPassEligibilityDescription(eligibility)">
        {{ orgConfigService.getGuestPassEligibilityDescription(eligibility) }}
        <ng-container *ngIf="eligibility === GuestPassEligibility.lapsedCustomersOnly">
          The window is configured under <a routerLink="/organization-settings" target="_blank">Organization Settings</a>.
        </ng-container>
      </small>
    </div>

    <div class="form-group">
      <label for="availableStartingAt">
        Becomes Available On (Optional)
      </label>
      <app-date-picker [id]="'availableStartingAt'"
                       [(content)]="availableStartingAt"></app-date-picker>
      <small class="form-text text-muted">
        If this is left blank, the guest pass will be available for use immediately.
      </small>
    </div>

    <div class="form-group">
      <label for="expiresAt">
        Expires On (Optional)
      </label>
      <app-date-picker [id]="'expiresAt'"
                       [(content)]="expiresAt"></app-date-picker>
      <small class="form-text text-muted">
        The guest pass will expire at the end of the chosen day. If this is left blank, the guest pass does not expire.
      </small>
    </div>

    <div class="form-group">
      <label for="name">
        Name (Optional)
      </label>
      <input type="text"
             class="form-control"
             id="name"
             name="name"
             [(ngModel)]="name">
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSave"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
